import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

interface UserState {
  firstName: string;
  lastName: string;
  personalDetails: Record<string, any>;
  formDetails: any;
  filteredFormData: any[];
  savedFormData: any[];
  sessionId: string;
}

const initialState: UserState = {
  firstName: '',
  lastName: '',
  personalDetails: {},
  formDetails: {},
  filteredFormData: [],
  savedFormData: [],
  sessionId: uuidv4(),
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setFirstName(state, action: PayloadAction<string>) {
      state.firstName = action.payload;
    },
    setLastName(state, action: PayloadAction<string>) {
      state.lastName = action.payload;
    },
    setPersonalDetails(state, action: PayloadAction<Record<string, any>>) {
      state.personalDetails = action.payload;
    },
    setFormDetails(state, action: PayloadAction<any>) {
      state.formDetails = action.payload;
    },
    setFilteredFormData(state, action: PayloadAction<any[]>) {
      state.filteredFormData = action.payload;
    },
    toggleSavedFormData(state, action: PayloadAction<any>) {
      const exists = state.savedFormData.includes(action.payload);
      state.savedFormData = exists
        ? state.savedFormData.filter(item => item !== action.payload)
        : [...state.savedFormData, action.payload];
    },
    setSessionId(state, action: PayloadAction<string>) {
      state.sessionId = action.payload;
    },
  },
});

export const {
  setFirstName,
  setLastName,
  setPersonalDetails,
  setFormDetails,
  setFilteredFormData,
  toggleSavedFormData,
  setSessionId,
} = userSlice.actions;
export default userSlice.reducer;
